import { Component } from '@angular/core';
import { Directionality } from '@angular/cdk/bidi';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'projects/shared/src/services/StorageService';
import { AuthenticationService } from 'projects/shared/src/services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent {
  title = 'CPA';

  constructor(
    public storageService: StorageService,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private router: Router,
    private directionality: Directionality
  ) {
    this.storageService.changes.subscribe(data => {
      if (data?.key == 'language' || data?.key == 'authUser') {
        window.location.reload();
      }
    });

    var lang = localStorage.getItem('language') || 'ar';
    localStorage.setItem('language', lang);
    var style = 'assets/css/en-US/style.css';
    var dir = 'ltr';
    if (lang == 'ar') {
      style = 'assets/css/ar-SA/style.css';
      dir = 'rtl';
    }
    let buildNumber = '1.0.5'
    style += buildNumber ? '?vr=' + buildNumber : '';
    document.getElementById('mainStyle')?.setAttribute('href', style);
    document.getElementById('html')?.setAttribute('lang', lang);
    document.getElementById('html')?.setAttribute('dir', dir);
    (this.directionality as any).value = dir;
  }
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(query => {

      if (query['refreshToken']) {
        this.retrieveSession(query['refreshToken'])
      }
    })
  }
  retrieveSession(refreshToken: string) {
    if (this.authenticationService.currentUserValue) {
      this.authenticationService.clearUserData()
    }
    this.router.navigate([this.router.url.split('?')[0]], { replaceUrl: true })
    this.authenticationService.RetrieveSession(refreshToken).subscribe(data => {
    }, err => {
      this.authenticationService.logout();
    });
  }
}
